import { toRefs, reactive } from "vue"
import axios from "axios"
import companyService from "./companyService"
import config from "../../config"

let alreadyCounted = false
const state = reactive({})

async function countScan() {

    console.log('countScan', alreadyCounted)

    if (alreadyCounted) {
        return
    }
    let companyId = companyService.company && companyService.company.value ? companyService.company.value.id : null
    if (!companyId) {
        return
    }

    alreadyCounted = true

    try {
        await axios.post(config.apiUrl + "/api/frontend/count-scan", { companyId })
    } catch (error) {
        console.warn("countScan failed", error && error.message)
    }
}




export default {
    ...toRefs(state),
    countScan
}


